import { Input, Select, Form, Button, DatePicker, Row, Col, Upload , Alert, message} from "antd";
import configs from "./configs.json";
import { PageHeader } from '@ant-design/pro-layout';
import { UploadOutlined, CloseOutlined, SyncOutlined } from "@ant-design/icons";
import validators from "./validators";
import TextArea from "antd/es/input/TextArea";
import { useDispatch, useSelector } from "react-redux";
import { resetForm, setFormAlert , setFormValue , setFormError, setFormValues } from "../features/formSlice";
import { firstLetterCaps, getFromPreload, getFromWorkspace, hasAllKeys, normalizeDates, resolveCondition, safeParse } from "../helpers/helper";
import { customTags } from "./custom";
import { Image } from "antd";
import { useState, useEffect } from "react";
import apiAction from "../ajax/service";
import { filter, isObject, isString } from "lodash";
import { setMessage } from "../features/rentSlice";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {formConditions, formCustomRequestAdditions, formCustomRequestNormalizer, formRequestAdditions} from "./formConditions"
import dayjs from "dayjs"
import {renderConditions} from "./renderConditions";
const conditionalProps = (params, values, key, id = -1, onChange, presets) => {

  let modifiedProps = {
    ...presets,
    placeholder: params.placeholder ?? "",
    value:
      values[key] !== undefined
        ? values[key]
        : params.value !== undefined
        ? params.value
        : params.type === "select"
        ? null
        : "",

    style: { width: params.extra ? "85%" : "100%" },
    onChange: (e) => onChange(key, (e && e.target) ? e.target.value : e, params.validation),
  };
  if(params.elementId || params.name){
    modifiedProps['id'] =  params.elementId || params.name
  }
  if (key.endsWith("Date") && values[key]) {
  modifiedProps.value = dayjs(values[key])
}

  let directApply = {
    maxLength: "maxLength",
    label: "placeholder",
    required: "required",
  };

  for (var param of Object.keys(params)) {
    if (directApply[param]) {
      modifiedProps[directApply[param]] = params[param];
    }
  }
  if (params.options) {
    if (params.options.length && typeof params.options[0] === "object") {

      modifiedProps["options"] = params.options?.map((item) => {
        if (hasAllKeys(item,["key","label","value"])){
          return item
        }
        if (Object.keys(item).length === 1) {
          const [[key, value]] = Object.entries(item);
          return {
            key : key,
            label : value,
            value: key
          }
        }
        const dataId = item["id"];

        return {
          key: dataId,
          label: Object.values(item).join(" - "),
          value: dataId
        };
      });
    } else {
      modifiedProps["options"] = params.options?.map((item) => {
        if (params.options?.length == 2 && isString(item) && new Set(["yes","no"]).has(item.toLocaleLowerCase())){
          return item.toLowerCase() == "yes" ? {key:item,label:item,value:true} : {key:item,label:item,value:false}
        }
        return {
          key: item,
          label: item,
          value: item,
        };
      });
    }
  }
  if (params.dependsOn) {
    if (params.dependsOn.indexOf("::") > -1){
      let [field , condition] = params.dependsOn.split("::")
      var res = resolveCondition(values[field],condition)
      modifiedProps["disabled"] = !res
      // condition = JSON.parse(condition)
      // switch (condition[0]){
      //   case "is":
      //     if (values[field] && values[field].toString() === condition[1]){
      //       modifiedProps["disabled"] = false;
      //     } else {
      //       modifiedProps["disabled"] = true;
      //     }
      //     break
      //   case "not":
      //     if (values[field] && values[field].toString() !== condition[1]){
      //       modifiedProps["disabled"] = false;
      //     } else {
      //       modifiedProps["disabled"] = true;
      //     }
      //     break
      // }

    } else {
    if (!(params.dependsOn in values)) {
      modifiedProps["disabled"] = true;
    }
  }
  }
  return modifiedProps;
};

export const ElementRender = (key, type, params, values, id = -1, onChange, presets, extras) => {
  if (new Set(Object.keys(customTags)).has(type)) {
    return customTags[type]({
      ...conditionalProps(params, values, key, id, onChange,presets[key]),
      ...extras
    });
  }
  if (type === "select") {
    return (
      <Select
        allowClear
        {...conditionalProps(params, values, key, id, onChange,presets[key])}
      />
    );
  } else if (type === "text") {
    return (
        <Input
            {...conditionalProps(params, values, key, id, onChange,presets[key])}
        />
    );
  } else if (type === "textarea") {
    return (
      <TextArea {...conditionalProps(params, values, key, id, onChange,presets[key])} />
    );
  } else if (type === "number") {
    return (
      <>
      <Input
        type="number"
        {...conditionalProps(params, values, key, id, onChange,presets[key])}
      /> {params.extra && <span dangerouslySetInnerHTML={{ __html: params.extra }} />}

      </>
    );
  } else if (type === "imageArray") {
    const maxImages = params.max || 5;
    const currentImages = values[key] ? safeParse(values[key]) : [];
    return (
      <div style={{ display: "flex", gap: 8 }}>
        {[...Array(maxImages)].map((_, idx) => {
          const imgUrl = currentImages[idx];
          return imgUrl ? (
            <div
              key={`${id}-${key}-img-wrap-${idx}`}
              style={{ position: "relative", display: "inline-block" }}
            >
              <Image
                key={`${id}-${key}-img-${idx}`}
                src={imgUrl}
                width={60}
                height={60}
                style={{ objectFit: "cover", borderRadius: 4 }}
                alt={`Image ${idx + 1}`}
                fallback="https://via.placeholder.com/80"
                preview={true}
              />
              <Button
                type="text"
                danger
                size="small"
                icon={<CloseOutlined style={{ color: "white", height: 10, width: 10 }} />}
                style={{
                  position: "absolute",
                  top: -2,
                  right: -2,
                  zIndex: 2,
                  background: "grey",
                  borderRadius: "50%",
                  padding: 0,
                  width: 12,
                  height: 12,
                  lineHeight: "22px",
                }}
                onClick={() => {
                  const newImages = [...currentImages];
                  newImages[idx] = undefined;
                  onChange(key, newImages);
                }}
              />
            </div>
          ) : (
            <Upload
              key={`${id}-${key}-upload-${idx}`}
              showUploadList={false}
              accept="image/*"
              beforeUpload={(file) => {
              // Check individual file size
              if (file.size > 2 * 1024 * 1024) {
                message.error(`Image ${idx + 1} exceeds 4MB limit`);
                return false;
              }

              const reader = new FileReader();
              reader.onload = (e) => {
                const newImages = [...currentImages];
                newImages[idx] = e.target.result;

                // Check total size of all images combined
                const totalSize = newImages.reduce((acc, img) => {
                  if (!img) return acc;
                  // base64 string → approximate byte size
                  const base64Data = img.split(',')[1] || img;
                  return acc + Math.ceil((base64Data.length * 3) / 4);
                }, 0);

                if (totalSize > 2 * 1024 * 1024) {
                  message.error('Total size of all images must be under 4MB');
                  return;
                }

                onChange(key, newImages);
              };
              reader.readAsDataURL(file);
              return false;
            }}

            >
              <Button icon={<UploadOutlined />} style={{ width: 60, height: 60 }}></Button>
            </Upload>
          );
        })}
      </div>
    );
  } else if (type === "date") {
    return (
        <DatePicker showTime={params.showTime}
            {...conditionalProps(params, values, key, id, onChange,presets[key])}
        />
    );
  }
  return null;
};

const DynamicForm = () => {
  const [discard , setDiscard] = useState(false)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let { modal: formKey } = useParams();
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search);
  const subTitle = queryParams.get("subtitle");
  let config = "";

  if (config === "" && formKey !== "") {
    config = configs[formKey];
  }
  const [form] = Form.useForm();
  const formValues = useSelector((state) => state.form.values);
  const formError = useSelector((state) => state.form.error);
  const preloadData = useSelector((state)=>state.workspace.preload)
  const workspaceData = useSelector((state)=>state.workspace)
  const availableAgreements = useSelector((state)=>state.rent.agreementInfo)
  const onlyOneAgreement = false
  const presets = useSelector(state=>state.form.presets)
  const id = useSelector((state) => state.form.id);
  const [loader , setLoader] = useState(false)
  const [refresh, setRefresh] = useState(0);
  const [validationStatus, setValidationStatus] = useState({});
  const [initialValues , setInitialValues] = useState(null)
  const [extras, setExtras] = useState({})
  const handleValueChange = (key, value, validator = null) => {
    let isValid = true;
    let values = null
    if (key.toLowerCase().endsWith("date")){
        if (!value){
          value = ""
        } else {
        value = value.format("YYYY-MM-DD");
        }
    }
    if (validator) {
      [isValid , values]= validators[validator](value, formValues);
      if (isObject(values) && values ){
      for (var k of Object.keys(values)){
        dispatch(setFormValue({ key :k, value:values[k] }));
      }
    }
    }

    setValidationStatus(prevStatus => ({
      ...prevStatus,
      [key]: isValid ? 'success' : 'error'
    }));



      dispatch(setFormValue({ key, value }));

  };

  // useEffect(() => {
  //   form.resetFields();
  //   setValidationStatus({});
  // }, [formKey,id]);

  useEffect(()=>{
    form.resetFields();
    setValidationStatus({});
    let action = "getById"
    let reqBody = {modal : formKey , id : id }
    if (formKey in formCustomRequestAdditions) {
      action = "custom"
      reqBody = {...reqBody, filters:{id:reqBody.id , ...formCustomRequestAdditions[formKey]}}
    }
    if (id == -1){
      setInitialValues(formValues)
      return;}
    // if (formKey == prevFormKey && id == prevId) return
    apiAction("forms", reqBody , action)
    .then((data)=>{
      let extras;
      var fetchedFormValues = {...formValues}
      if(formKey in formCustomRequestNormalizer) {
        [data, extras] = formCustomRequestNormalizer[formKey](data?.[0] || data)
        setExtras(extras)
      }
      config.map((item)=>{
        if (item.name in data){
          fetchedFormValues[item.name] = data[item.name]
        }
      })
      dispatch(setFormValues(fetchedFormValues))
      setInitialValues(fetchedFormValues)
      handleRefresh()
      message.success("Fetched Latest Data !!!")

    }).catch(()=>{
      console.log("Failed to fetch latest!!")
    })
  },[id,formKey])
  useEffect(()=>{
    if (id != -1 && initialValues !== null) {
      form.setFieldsValue(initialValues)
      form.validateFields()
    }
  },[initialValues])
    useEffect(()=>{
    if (formValues !== null) {
      form.setFieldsValue(formValues)

    }
  },[formValues])
  const submitForm = () => {
    form.validateFields().then(() => {
      let action = "add";
      if (formKey == "eventAgreement") formKey = "rentalAgreement"
      var reqObj = { ...formValues, modal: formKey }
      if (id !== -1) {
        action = "update";
        reqObj = {...validators.pickDataToUpdate(formValues , initialValues) , id:id, modal:formKey}
      }
      if (formKey == "rentalAgreement"){

        if (formConditions['submitConditions'][formKey](availableAgreements ,onlyOneAgreement ,{ ...formValues})){
          dispatch(setFormError("Agreements are overlapping , Check the agreement date or toggle agreement can overlap option for the product"))
          return
        } else {
          if (onlyOneAgreement) reqObj = {...reqObj , onlyOneAgreement  }
        }
      }
      apiAction("forms",reqObj , action)
        .then(() => {
          dispatch(
            setMessage({
              type: "success",
              data: `${action} operation successful`,
            })
          );
          handleRefresh()
          dispatch(resetForm())
          form.resetFields();
          setValidationStatus({});
          message.success("Operation Successful!!")
          navigate(-1);

        })
        .catch((data) => {
          if (data.error){
            dispatch(setFormError(data.error))
            return
          }
        dispatch(setFormError("Issues Connecting to Server"));
        });
    }).catch(info => {
      console.log('Validate Failed:', info);
    });
  };

  const handleRefresh = () => {
    setRefresh(refresh + 1);
  };

  return (
    <>
      {config !== "" && (
        <PageHeader
          ghost={false}
          onBack={() =>{
            if (validators.dirtyCheck(formValues,initialValues )){
              if (!discard) {
                dispatch(setFormError("Form Has unsaved changes , Press back Again to discard  "))
                setDiscard(true)
                return
              }
            }
            dispatch(resetForm());
            navigate(-1)
            form.resetFields();
            setValidationStatus({});
          }
          }
          title={firstLetterCaps(formKey)}
          subTitle={subTitle ? subTitle : (id === -1 ? "Create new" : "Edit existing")}
          extra={[

            <Button key="1" type="primary" onClick={submitForm} disabled={Object.values(validationStatus).indexOf('error')>-1}>
              {id == -1 ? "Submit" : "Update" }
            </Button>,
          ]}
          style={{ padding: '24px 24px' }}
        >
          <Form form={form} layout="vertical" autoComplete="on" >
            {(Date.now() - new Date(formError.timeStamp)) <= 5000 && formError.message.length > 0 && <Alert closable type="error" message={formError.message} banner />}
            <Row gutter={24}>
              {config.map((item) => {
                if (item.dataSource) {
                  if (item.fetched === undefined || item.fetched !== refresh) {
                    var filters = { withKey: true, orderBy: { ["updatedAt"]: "desc" } }
                    if(item.dataSource.startsWith('tenant')){
                      filters = {...filters , archived:false}
                    }
                    if (item.dataSource.startsWith('preload')){
                       item["options"] = getFromPreload(preloadData , item.dataSource )
                       item["fetched"] = refresh + 1;
                    } else if (item.dataSource.startsWith('workspace')){
                      const values = getFromWorkspace(workspaceData,item.dataSource, "select")
                      if (values.length){
                        item["options"] = values
                        item["fetched"] = refresh + 1;
                      }

                    } else {
                    apiAction(
                      "filters",
                      {
                        field: item.dataSource,
                        filters: filters,
                      },
                      "getUniqueInField"
                    )
                      .then((value) => {
                        item["options"] = value.data ? value.data : value;
                        item["fetched"] = refresh + 1;
                        setRefresh(refresh + 1);
                      })
                      .catch(() => {
                        item["fetched"] = refresh + 1;
                        setRefresh(refresh + 1);
                      });
                  }}
                }
                 if (item.renderCondition){
                    let [func , condition] = item.renderCondition.split("::")
                    if (!resolveCondition(renderConditions[func](formValues),condition)){
                      return <></>
                    }
                  }
                  if(!item.type){
                    return <></>
                  }
                  if(item.blockUpdate){
                    if(id !== -1){
                      return <></>
                    }
                  }
                return (
                  <Col xs={24} md={item.fullsize ? 24 : 12} key={item.name + id}>
                    <Form.Item
                      label={item.label}
                      name={item.name}
                      required={item.required ?? false}
                      rules={[{ required: item.required, message: `Please enter ${item.label}` }]}
                      hasFeedback
                      valuePropName={item.name}
                      validateStatus={validationStatus[item.name]}
                    >
                      {ElementRender(item.name, item.type, item, formValues, id, handleValueChange, presets, extras)}
                    </Form.Item>
                  </Col>
                );
              })}
            </Row>
          </Form>
        </PageHeader>
      )}
    </>
  );
};

export default DynamicForm;
